export const FAILED: AcceptanceCheckResult = 'Failed';
export const PASSED: AcceptanceCheckResult = 'Passed';